<template>
  <Modal :mayCancel="true" v-on:done="onDone" v-on:cancel="onDone">
    <p>
      In order to upload images to Browserboard, you need to be logged in. This
      limitation exists to keep the site free.
    </p>
    <div class="ButtonRow-FlexRight">
      <div></div>
      <SignupButton></SignupButton>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import SignupButton from "@/components/SignupButton.vue";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal, SignupButton } })
export default class FeatureGateForImageUploadModal extends Vue {
  onDone() {
    ModalMutations.closeModals(this.$store.commit);
  }
}
</script>

<style scoped lang="scss"></style>
